
<template>
  <div class="froot" ref="compElement">
    <div class="ffoot" v-if="showFirstLine">
      <div v-bind:style="{ width: getWidthToWaves() }" style="display:inline-block;" />
      <div v-if="!internalSmallscreenactive" class="pc">
        <div class="pline" style="padding-top: 0.375rem;">
          <scale  ref="scale"
                  style="height:0.75rem; width: 100%;"
                  :proportional="true"
                  :showText="false"
                  :smallFont="true"
                  :thresholds="thresholds"/>
        </div>
      </div>
      <div v-bind:style="{ width: getWidthToRight() }" style="display:inline-block;" />
      <div v-if="!internalSmallscreenactive" class="pr">
        <div class="pline"></div>
      </div>
    </div>
    <div class="ffoot" v-if="showSecondLine">
      <div v-bind:style="{ width: getWidthToWaves() }" style="display:inline-block;" />
      <div class="pline"> <!-- style="padding: 0.25rem; width: 100%;">-->
        <template v-for="index in getThresholdLength()">
          <div class="reslegcurbox" :style="getThresholdColorFromIndex(index-1)" :key="`${index}_color`" />
          <div class="ftxt" :key="`${index}_text`">{{ tooltipText(index-1) }}</div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import AppConfig from '@/mixins/AppConfig-APP_TARGET';
import scale from './Scale';

export default {
  name: 'Foot',

  components: { scale },

  mixins: [ AppConfig ],

  props: {
    dashdata: { type: Object, default: null, required: true },
    showFirstLine: { type: Boolean, default: true },
    showSecondLine: { type: Boolean, default: true },
    thresholds: null,
    smallscreenactive: { type: Boolean, default: false },
    smallScreenSwitchWidth: {type: Number, default: 120},
    widthToBar: { type: String, default: '448px' },
  },

  data() {
    return {
      internalSmallScreenSwitchWidth: 120,
      internalSmallscreenactive: false,
    };
  },

  mounted() {
    this.internalSmallScreenSwitchWidth = this.smallScreenSwitchWidth;
    this.internalSmallscreenactive = this.smallscreenactive;
    this.getClientWidth();
    window.addEventListener('resize', this.handleResize);
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },

  methods: {

    handleResize (event) {
      this.getClientWidth();
    },

    getClientWidth() {
      let ele = this.$refs.compElement;
      if (ele && ele.clientWidth && ele.clientWidth > 0) {
        if (this.currentWidth !== ele.clientWidth) {

          this.currentWidth = ele.clientWidth;
          const left = Number(this.getWidthToWaves().replace('px', '')) + 7; // column padding 7px
          const right = Number(this.getWidthToRight().replace('px', ''));
          // console.log('Foot - left: ' + left + ' - right: ' + right + ' - width: ' + this.currentWidth + ' - diff: ' + (this.currentWidth - left - right));
          this.internalSmallscreenactive = (this.currentWidth - left - right) < this.internalSmallScreenSwitchWidth;
        }
      }
    },

    getPreviousWave() {
      let name = '';
      if (this.dashdata.wavenames.length < 2) {
        name = 'N/A';
      } else {
        if (!_.isEmpty(this.dashdata.OverallByWave[0])) {
          name = this.getPreviousWaveName(this.dashdata.OverallByWave[0]);
        }
      }
      return this.$t('Webportal.PreviousWave') + ': ' + name;
    },

    getCurrentWave() {
      let name = '';
      if (!_.isEmpty(this.dashdata.OverallByWave[0])) {
        name = this.getCurrentWaveName(this.dashdata.OverallByWave[0]);
      }
      return this.$t('Webportal.CurrentWave') + ': ' + name;
    },

    getWidthToWaves() {
      return this.widthToBar;
    },

    getWidthToRight() {
      // Each wave will take 150px width (Total 'Wave' is at the end)
      // +1 border
      return '151px';
    },

    tooltipText(index) {
      let retVal = '';

      if (this.thresholds && this.thresholds.length > index) {
        retVal = this.thresholds[index].Minimum + '-' + this.thresholds[index].Maximum + '%';
      }

      return retVal;
    },

    getThresholdLength() {
      return this.thresholds ? this.thresholds.length : 0;
    },

    getThresholdColorFromIndex(index) {
      let retVal = 'background-color: #ff201c;';

      if (this.thresholds && this.thresholds.length > index) {
        retVal = 'background-color: ' + this.thresholds[index].Color + ';';
      }

      return retVal;
    }
  }
};

</script>


<style scoped>

.pline {
  height: 1.5rem;
}

.pl {
  width: 440px; /* or leave it undefined */
}
.pc {
  flex-grow: 1;
  min-width: 250 !important;
}
.pr {
  width: 7px; /* cell padding */
}
.pitem {
  text-align: center;
  height: 1rem;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  /* width: 300px; */
 /*  */
}

</style>
